import React from "react";
import { ManageSubscriptionState } from "./models";

import {
    t,
    Trans
} from "@lingui/macro";

import {
    Box, Button, Typography
} from "@mui/material";

import { ContentProducerService } from "services/content-producer-service";
import { DefaultTypedResponse } from "models/response";
import ZPlayLoader from "commons/zplay-loader";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { WithSnackbarProps, withSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Subscription } from "models";
import { SubscriptionTable } from "components/backoffice/subscription";

class ManageSubscription extends React.Component<WithSnackbarProps & RouteComponentProps<any>, ManageSubscriptionState>
{
    constructor(props: any) {

        super(props);

        this.state = {
            searchFilter: null,
            pagination: { pageSize: 20, pageIndex: 0 },
            subscriptionList: [],
            subscriptionListCount: 0,
            isLoading: true
        };
    }

    public componentDidMount() {
        ContentProducerService.getSubscriptionsListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getSubscriptionsCallback, this.getSubscriptionsErrorCallback);
    }

    private getSubscriptionsCallback = (data: DefaultTypedResponse<Subscription>): void => {

        this.setState(() => ({
            subscriptionListCount: data.size,
            subscriptionList: data.list,
            isLoading: false
        }));

    };

    private getSubscriptionsErrorCallback = (err: any): void => {

        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ms-error-get",
            message: "Si è verificato un errore. Non è stato possibile recuperare i dati"
        }), {
            variant: "error",
        });
    };

    private parseQueryParamsFromState = (values: any): [string, any][] => {

        let queryParamsToReturn: [string, any][] = [];

        queryParamsToReturn.push(["pageId", this.state.pagination.pageIndex + 1]);
        queryParamsToReturn.push(["pageSize", this.state.pagination.pageSize]);

        if (values.title && values.title !== "")
            queryParamsToReturn.push(["searchText", values.title]);

        return queryParamsToReturn;
    }

    private paginationUpdated = (pagination: any) => {

        this.setState(() => ({
            isLoading: true,
            pagination: pagination
        }), () => ContentProducerService.getSubscriptionsListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getSubscriptionsCallback, this.getSubscriptionsErrorCallback));
        ;

    }

    private deleteSubscription = (id: string) => {

        this.setState(() => ({
            isLoading: true
        }));

        if ((this.state.subscriptionList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
            this.setState((prevState) => ({
                pagination: {
                    ...prevState.pagination,
                    pageIndex: this.state.pagination.pageIndex - 1
                }
            }));
        };

        ContentProducerService.deleteSubscription(id, this.deleteSubscriptionCallback, this.deleteSubscriptionErrorCallback)
    }

    private deleteSubscriptionCallback = (id: string) => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ms-success-delete",
            message: "Abbonamento eliminato con successo"
        }), {
            variant: "success",
        });

        ContentProducerService.getSubscriptionsListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getSubscriptionsCallback, this.getSubscriptionsErrorCallback);
    }

    private deleteSubscriptionErrorCallback = (id: string) => {
        this.setState(() => ({
            isLoading: false
        }));

        this.props.enqueueSnackbar(t({
            id: "ms-error-delete",
            message: "Si è verificato un errore. L'abbonamento non è stata eliminato"
        }), {
            variant: "error",
        });
    }

    private goToCreate = (): void => {
        let { history } = this.props
        history.push(`/backoffice/create-subscription`);

    }

    render() {
        return (
            <Box sx={{ textAlign: "center", p: 5 }}>
                <NavigationBack/>
                <Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                    <Trans id="subscription-text-title">Abbonamenti</Trans>
                </Typography>
                <Box sx={{ textAlign: "right", pr: 2 }}>
                    <Button
                        endIcon={<AddIcon />}
                        onClick={this.goToCreate}
                        variant={"contained"}
                    >
                        <Trans id="ms-button-add">Aggiungi</Trans>
                    </Button>
                </Box>
                {!this.state.isLoading && <Box sx={{ p: 2, mt: 2 }}>
                    <SubscriptionTable
                        pagination={this.state.pagination}
                        subscriptions={this.state.subscriptionList}
                        totalSubscriptionsCount={this.state.subscriptionListCount}
                        deleteSubscription={this.deleteSubscription}
                        updatePaginationCallBackFn={this.paginationUpdated}
                    />
                </Box>}
                {this.state.isLoading && <ZPlayLoader />}
            </Box>);
    }
}

export default withRouter(withSnackbar(ManageSubscription));
